import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c7be857"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }

import { type ComputedRef, inject, computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

_useCssVars(_ctx => ({
  "7c61199d": (_unref(img))
}))

const images = inject<ComputedRef<Record<string, string>>>('images')!;
const img = computed(() => `url(${images.value['bg-red']})`);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default")
  ]))
}
}

})